<script>
import CategoryDescription from '@/components/category/Description.vue';

export default {
  name: 'CategoryDescriptionGlutenFree',
  components: {
    CategoryDescription,
  },
  props: {
    description: { required: true, type: String },
  },
};
</script>

<template>
  <div>
    <div>
      <h2>Our commitment to gluten-free products</h2>
      <p class="longprimer">
        While we’ve always sold naturally gluten-free products, we’ve gone a step farther to offer
        an even wider range of trusted, affordable, and certified gluten-free products.
      </p>
      <ul class="prose">
        <li>
          We analyzed ingredients, vetted suppliers, and got facility certificates ensuring
          non-contamination of ingredients and production aids.
        </li>
        <li>
          We completely segregated our production lines to eliminate any possibility of
          cross-contamination.
        </li>
        <li>
          We established policies and procedures to ensure compliance and randomly test products in
          our gluten-free production room.
        </li>
        <li>
          Not only do we voluntarily comply with USDA federal guidelines, but we’re also certified
          by the Gluten-Free Certification Organization.
        </li>
        <li>We show the GF logo on each product page that is gluten-free.</li>
      </ul>
    </div>
    <CategoryDescription :description="description" />
  </div>
</template>
